import type { DiagramProps } from '@/lib/scad-feature-types';
import { D } from './DiagramStyles';

export function MinkowskiDiagram(_props: DiagramProps) {
  return (
    <svg viewBox="0 0 280 150" width="100%" style={{ display: 'block' }} aria-label="Minkowski sum diagram">

      {/* A: rectangle */}
      <rect x={20} y={50} width={50} height={35}
            fill="rgba(96,165,250,0.15)" stroke={D.GEO_STROKE} strokeWidth="1.5" />
      <text x={45} y={42} fontSize="10" fontFamily="monospace"
            fill="currentColor" opacity="0.6" textAnchor="middle">A</text>

      {/* Plus */}
      <text x={84} y={73} fontSize="16" fontFamily="monospace"
            fill="currentColor" opacity="0.45" textAnchor="middle">⊕</text>

      {/* B: small circle */}
      <circle cx={108} cy={67} r={10}
              fill="rgba(34,197,94,0.2)" stroke="#22c55e" strokeWidth="1.5" />
      <text x={108} y={42} fontSize="10" fontFamily="monospace"
            fill="#22c55e" opacity="0.8" textAnchor="middle">B</text>
      {/* B radius label */}
      <line x1={108} y1={67} x2={118} y2={67}
            stroke="#22c55e" strokeWidth="1" strokeDasharray="2 2" opacity="0.7" />
      <text x={120} y={65} fontSize="8" fontFamily="monospace"
            fill="#22c55e" opacity="0.7">r</text>

      {/* Equals */}
      <text x={136} y={73} fontSize="14" fontFamily="monospace"
            fill="currentColor" opacity="0.4" textAnchor="middle">=</text>

      {/* Result: rectangle with rounded corners (A + circle radius) */}
      <rect x={148} y={50} width={50} height={35} rx={10} ry={10}
            fill="rgba(96,165,250,0.25)" stroke={D.GEO_STROKE} strokeWidth="1.5" />
      <text x={173} y={42} fontSize="10" fontFamily="monospace"
            fill="currentColor" opacity="0.6" textAnchor="middle">A ⊕ B</text>

      {/* Corner radius annotation */}
      <line x1={148} y1={57} x2={140} y2={50}
            stroke={D.DIM_STROKE} strokeWidth="1" strokeDasharray="2 2" opacity="0.6" />
      <text x={130} y={47} fontSize="8" fontFamily="monospace"
            fill={D.DIM_STROKE} opacity="0.7" textAnchor="middle">r = B radius</text>

      <text x="140" y="142" fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.4" textAnchor="middle">rounds/inflates A by the shape of B</text>
    </svg>
  );
}
